import { useEffect, useState } from "react"
import { getLegendLayer } from "../map/layers/LegendLayer"
import { MAP_IMAGE_LAYER_URL } from "../map/constants"
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils"
import { getView } from "../map"

export const useLegendLayerInfo = (layerId: number) => {
  const layer = getLegendLayer()
  const layerInfo = layer && layer.findSublayerById(layerId)
  return layerInfo
}

export const useLegendLayerUpdating = () => {
  const layer = getLegendLayer()
  const [updating, setUpdating] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [retryCount, setRetryInit] = useState<number>(0)

  useEffect(() => {
    if (layer) {
      const trackUpdating = async () => {
        const view = getView()
        if (!view) {
          setTimeout(trackUpdating, 1000)
          return
        }
        const layerView = await view.whenLayerView(layer)
        reactiveUtils.watch(() => layerView.updating, (isUpdating: boolean) => {
          setUpdating(isUpdating)
        })
      }
      trackUpdating()
    } else {
      setTimeout(() => {
        setRetryInit(initCount => initCount + 1)
      }, 500)
    }
  }, [layer])

  return updating
}

export const useLegendData = () => {
  const [data , setData] = useState({ layers: [] })
  useEffect(() => {
    async function fetchData() {
      const response = await fetch(MAP_IMAGE_LAYER_URL + '/legend?f=pjson')
      if (response.ok) {
        const legendData: any = await response.json()
        if (legendData && legendData.layers && legendData.layers.length) {
          setData(legendData)
        }
      }
    }
    fetchData()
  }, [])

  return data
}